import {Field} from 'formik'
import InputMask from 'react-input-mask'
import {ISetFieldValue} from '../../../../_metronic/helpers/custom/tsHelpers/generalHelpers'

interface Props {
  inputName: string
  value: string | number
  setFieldValue: ISetFieldValue
  numbersArray?: boolean
  index?: number
  handleChange?: (index: number, name: string, value: string) => void
}

export function PhoneNumberInput({
  inputName,
  setFieldValue,
  value,
  numbersArray = false,
  index,
  handleChange,
}: Props) {
  return (
    <Field
      name={inputName}
      render={() => (
        <InputMask
          name={inputName}
          type='tel'
          mask='(999) 999-99-99'
          className={`form-control form-control-lg form-control-solid`}
          value={value}
          maskChar={null}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            // @ts-ignore

            numbersArray === true && index && handleChange
              ? handleChange(index, 'phoneNumber', e.target.value)
              : setFieldValue(inputName, e.target.value)
          }}
        />
      )}
    />
  )
}
